<template>
  <div style="width: 100%">
    <header id="wrapper-header" class="wrapper-header gradient" role="main">
      <div class="container app-container">
        <div class="row">
          <div class="wrapper-header-block col-12">
            <h2 class="title">Uploads</h2>
            <!-- <div>
              <label class="typo__label">Segmento</label>
              <multiselect v-model="value" tag-placeholder="Add this as new tag" placeholder="Busque pelos CNAE" label="name" track-by="code" :options="options" :multiple="true" :taggable="true"></multiselect>
            </div> -->

            <!--<BusinessFilterV2 v-if="bShowBusinessFilter" :b-show-fields-and-mini-dashboard=true-->
                              <!--:b-show-grid-result=true v-on:DrawBegin="DrawBegin" :GeoPolygon="sGeoPolygon"></BusinessFilterV2>-->
          </div>
        </div>
      </div>
    </header>
    <div class="container app-container">
      <div class="row">
        <input type="file" id="uploadTest" style="display: block;width: 100px;margin: auto;">
        <vue-dropzone id="dzUploadControl" class="uploadTable" style="width: 100%"
              :options="dropzoneOptions"
              v-on:vdropzone-sending="sendingEvent"
              @vdropzone-canceled="vueDropzoneCanceled"
              @vdropzone-success="vueDropzoneSuccess"
              @vdropzone-error="vueDropzoneError"
              @vdropzone-sending="vueDropzoneSending"
              ref="dropzoneInstance"
        />
          <div class="table-uploads-block">
            <b-card-body>
              <b-row>
                <b-col>
                  <h6 class="title" v-if="showCheckingMessage">{{fileCheckingMessage}}<i class="fas fa-sync fa-spin" style="color:darkorange"></i></h6>
                </b-col>
                <b-col>
                  <h6 class="title" style="float: right">Tamanho do arquivo: {{FormatBytes(dropzoneOptions.maxFilesize) }} | Número de linhas: {{ dropzoneOptions.maxRows }} | Número de colunas: {{ dropzoneOptions.maxColumns }}</h6>
                </b-col>
              </b-row>
            </b-card-body>
            <div :key="`my-upload-files-${tableDataKey}`">
              <b-overlay :show="busy" rounded="lg" opacity="0.6">
                <template #overlay>
                  <div class="d-flex align-items-center">
                    <span>Carregando...&nbsp;<i class="fa fa-spinner fa-pulse fa-xl"></i></span>
                  </div>
                </template>
                <b-table id="my-upload-files" striped hover small :items="listFiles" :fields="listFilesSettings">
                  <template #cell(cMime)="data">
                    <i :class="fileIcon(data.item.cName)"></i>
                    {{ data.item.cName }}
                  </template>
                  <template #cell(actions)="data">
                    <b-dropdown :id="formatClass(data.item.cName)" class="file-item-actions" variant="default btn-round icon-btn borderless md-btn-flat hide-arrow" size="sm">
                      <template slot="button-content"><i class="fas fa-ellipsis-h"></i></template>
                      <b-dropdown-item href="javascript:void(0)" @click="showPageConfigTable(data.item)"><i class="fa-solid fa-layer-group"></i>&nbsp;Criar camada</b-dropdown-item>
                      <!--<b-dropdown-item href="javascript:void(0)">Atualizar camada</b-dropdown-item>-->
                      <b-dropdown-item href="javascript:void(0)" @click="deleteFile(data.item)"><i class="fa-solid fa-trash"></i>&nbsp;Excluir arquivo</b-dropdown-item>
                      <b-dropdown-item href="javascript:void(0)" @clikc="" v-if="false"><i class="fa-solid fa-download"></i>&nbsp;Baixar arquivo</b-dropdown-item>
                    </b-dropdown>
                  </template>
                  <template #cell(dtAddIn)="data">
                    <span class="date">
                      <i class="icon-date"><img src="../../assets/icons/calendar.svg"></i>{{formatDate(data.item.dtAddIn)}}
                      <i class="icon-date"><img src="../../assets/icons/clock-circular.svg"></i>{{formatHora(data.item.dtAddIn)}}
                    </span>
                  </template>
                  <template #cell(nSize)="data">
                    {{FormatBytes(data.item.nSize)}}
                  </template>
                </b-table>
              </b-overlay>
            </div>
            <b-pagination :total-rows="totalRows" :per-page="perPage" @change="handlePageChange"
              v-model="currentPage" aria-controls="my-upload-files" v-show="perPage !== 0">
            </b-pagination>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import Vue from 'vue'
import Services from '../http/request'
import messenger from '../messenger/messenger'
import VueUploadComponent from 'vue-upload-component'
import {ColumnChooser, Toolbar, Page, Resize, Filter, Sort, Group, CommandColumn} from '@syncfusion/ej2-vue-grids'
import {ToolbarPlugin, AccordionPlugin} from '@syncfusion/ej2-vue-navigations'
import moment from 'moment'
import io from 'socket.io-client'
import uploadOptions from '../mixins/uploadOptions'
import { Static } from '../../service/Static'
import { Importer } from '../../service/Importer'

Vue.filter('fileSize', function (value) {
  if (!value) return ''
  const parts = String(value).split('.')
  return `${parts[0]}.${parts[1].slice(0, 2)}`
})
Vue.use(ToolbarPlugin, AccordionPlugin)
export default {
  name: 'upload-manager',
  components: {
    vueDropzone: vue2Dropzone,
    FileUpload: VueUploadComponent
  },
  metaInfo: {
    title: 'Uploads'
  },
  provide: {grid: [ColumnChooser, Toolbar, Resize, Page, Filter, Sort, Group, CommandColumn]},
  data: () => ({
    filterOptions: {type: 'Excel'},
    pageSettings: {pageSize: 8},
    toolbarOptions: ['ColumnChooser'],
    templateTitle: '<div class="e-tool-name">' + 'Uploads ' + '</div>',
    bgc: {
      backgroundColor: '#efbd06'
    },
    busy: false,
    viewMode: 'col',
    selected: [],
    focused: null,
    dropdownOpened: null,
    listFiles: [],
    tableDataKey: 0,
    showCheckingMessage: false,
    fileCheckingMessage: '',
    listFilesSettings: [
      {
        key: 'cMime',
        label: 'Tipo'
      },
      {
        key: 'cName',
        label: 'Nome',
        sortable: true
      },
      {
        key: 'nSize',
        label: 'Tamanho',
        sortable: true
      },
      {
        key: 'dtAddIn',
        label: 'Data',
        sortable: true
      },
      {
        key: 'actions',
        label: 'Ações'
      }
    ],
    icons: {
      xls: 'far fa-file-excel',
      csv: 'far fa-file-text',
      archive: 'far fa-file-archive',
      audio: 'far fa-file-audio',
      video: 'far fa-file-video',
      js: 'fab fa-js',
      doc: 'far fa-file-word',
      html: 'fab fa-html5',
      pdf: 'far fa-file-pdf',
      txt: 'far fa-file-alt',
      css: 'fab fa-css3',
      unknown: 'far fa-file'
    },
    dropzoneOptions: uploadOptions.dropzoneOptions,
    currentPage: 1,
    perPage: 8,
    totalRows: 1,
    staticService: Static.build({}),
    importerService: Importer.build({})
  }),
  methods: {
    listenSocketQueues: function () {
      try {
        let request = new Services({ tag: 'messenger' })
        let endPoint = `${request.getServiceEndPoint({})}`
        let socket = io(endPoint)

        socket.on('file.validation.failed', this.onFileValidationFailed)
        socket.on('file.validation.succeeded', this.onFileValidationSucceeded)
      } catch (e) {
        console.log(e)
      }
    },
    toolbarAction (e) {
      switch (e.item.text) {
        case '':
          this.$bus.$emit('closeSliders')
          break
        default:
          // Nada Acontece
      }
    },
    onFileValidationFailed(e) {
      const self = this
      let userId = parseInt(Vue.prototype.$foundation.getTokenClaims()['UserId'])
      if (e.UserId === userId) {
        self.showCheckingMessage = false
        self.getFiles()
        const message = `Parece que o arquivo possui problemas.`
        messenger.warn({ position: 'center', title: message })
      }
    },
    onFileValidationSucceeded(e) {
      const self = this
      const userId = parseInt(Vue.prototype.$foundation.getTokenClaims()['UserId'])
      if (e.UserId === userId) {
        self.showCheckingMessage = false
        self.getFiles()
        // const message = `Tudo bem com o arquivo, podemos seguir.`
        // messenger.info({ position: 'center', title: message })
      }
    },
    sendingEvent (file, xhr, formData) {
      formData.append('cName', file.name)
      formData.append('nLastModified', file.lastModified)
      formData.append('nSize', file.size)
      formData.append('cMime', file.type)
    },
    isFolder (file) {
      return file.type === 'dir'
    },
    isImage (file) {
      return false
    },
    isFile (file) {
      return true
    },
    fileIcon: function (file) {
      let icon = this.icons.unknown
      if (/\.xls$|\.xlsx$/i.test(file)) icon = this.icons.xls
      if (/\.csv$|\.tsv$|\.txt$/i.test(file)) icon = this.icons.txt
      if (/\.mp3$|\.wma$|\.ogg$|\.flac$|\.aac$/i.test(file)) {
        icon = this.icons.audio
      }
      if (/\.avi$|\.flv$|\.wmv$|\.mov$|\.mp4$/i.test(file)) {
        icon = this.icons.video
      }
      if (/\.js$|\.es6$|\.ts$/i.test(file)) icon = this.icons.js
      if (/\.doc$|\.docx$/i.test(file)) icon = this.icons.doc
      if (/\.htm$|\.html$/i.test(file)) icon = this.icons.html
      if (/\.pdf$/i.test(file)) icon = this.icons.pdf
      if (/\.txt$/i.test(file)) icon = this.icons.txt
      if (/\.css$/i.test(file)) icon = this.icons.css

      return `${icon} fa-lg`
    },
    toggleSelect (checked, item) {
      if (checked) {
        this.selected.push(item)
      } else {
        this.selected.splice(this.selected.indexOf(item), 1)
      }
    },
    focusIn (item) {
      this.focused = item
    },
    focusOut () {
      this.focused = null
    },
    dropdownShown (item) {
      this.dropdownOpened = item
    },
    dropdownHidden () {
      this.dropdownOpened = null
    },
    getConfig: function () {
      const self = this
      this.dropzoneOptions.headers.Authorization = Vue.prototype.$foundation.getUserToken()
      this.dropzoneOptions.url = this.getUploadUrl()
      const environment = Vue.prototype.$foundation.getEnvironmentName()
      this.importerService.getConfiguration(environment).then((res) => {
          if (res.status >= 200 && res.status < 300) {
            if (res.data.length === 0) {
              console.warn(`A consulta não retornou resultados para o environment '${environment}'.' `)
              return false
            }
            const jbData = res.data[0].jbdata
            if (jbData == null) {
              console.warn(`O environment '${environment}' não possui configurações no jbData.' `)
              return false
            }
            if (!jbData.hasOwnProperty("upload")) {
              console.warn(`O environment '${environment}' não possui configurações de upload no jbData.' `)
              return false
            }
            if (!jbData.upload.hasOwnProperty("config")) {
              console.warn(`O environment '${environment}' não possui configurações de upload.' `)
              return false
            }
            const uploadConfig = jbData.upload.config
            uploadOptions.dropzoneOptions.maxRows = uploadConfig.maxRows || 500000
            uploadOptions.dropzoneOptions.maxFiles = uploadConfig.maxFiles || 5
            uploadOptions.dropzoneOptions.maxColumns = uploadConfig.maxColumns || 70
            uploadOptions.dropzoneOptions.maxFilesize = uploadConfig.maxFilesize || 1000000
            uploadOptions.dropzoneOptions.acceptedFiles = uploadConfig.acceptedFiles || ".xls,.xlsx,.csv,.tsv"
          } else {
            const message = res.data.message || res.data || `Erro ao ler configurações`;
            console.error(message)
            messenger.error({ position: 'center', title: message })
          }
      })
    },
    getFiles: function () {
      this.busy = true
      const validExtension = ['.csv', '.tsv', '.txt', '.xls', '.xlsx', '.zip', '.rar', '.kml', '.kmz', '.geojson']
      let fileList = []
      const self = this
      const environmentId = Vue.prototype.$foundation.getEnvironmentId()
      const skip = this.currentPage
      const take = this.perPage
      this.importerService.getFiles(environmentId, skip, take).then((res) => {
          if (res.status >= 200 && res.status < 300) {
            self.totalRows = parseInt(res.headers['x-record-count'])
            const json = res.data
            for (let item = 0; item < json.length; item++) {
              if (validExtension.includes(json[item].cExt)) {
                fileList.push(json[item])
              }
            }
            // fileList.reverse()
            self.listFiles = fileList
            self.tableDataKey++
          } else {
            const message = res.data.message || res.data || `Erro ao obter os arquivos`;
            console.error(message)
            messenger.error({ position: 'center', title: message })
          }
          self.busy = false
      }, (error) => {
        messenger.error({position: 'top-end', title: error.message})
        console.log(error)
      })
    },
    getUploadUrl () {
      // const request = new Services({tag: 'upload'})
      // const endPoint = `${request.getServiceEndPoint({})}/api/0.1-a/importer/files`
      const request = new Services({tag: 'static'})
      const endPoint = `${request.getServiceEndPoint({})}/api/0.1-a/FileManager`
      return endPoint
    },
    handlePageChange(value) {
      this.currentPage = value
    },
    vueDropzoneCanceled(file, message, xhr) {
      this.showCheckingMessage = false
      console.log(file, message, xhr)
    },
    vueDropzoneError(file, message, xhr) {
      this.showCheckingMessage = false
      console.log(file, message, xhr)
    },
    vueDropzoneSending(file, message, xhr) {
      xhr.ontimeout = (e) => {
        console.log("Argh I timed out")
      };
    },
    vueDropzoneSuccess (reffile, res) {
      // console.log('Upload com Sucesso.')
      this.$refs.dropzoneInstance.removeFile(reffile)
      this.fileCheckingMessage = `Verificando o arquivo '${reffile.name}'...aguarde.`
      this.showCheckingMessage = true
      const fileId = res[0].gdIdEvent
      this.importerService.analyzeFile(fileId).then((res) => {

      }, (error) => {
        messenger.error({position: 'top-end', title: error.message})
        console.log(error)
      });
    },
    FormatBytes (bytes) {
      return uploadOptions.formatBytes(bytes)
    },
    deleteFile (value) {
      const self = this
      this.busy = true
      let options = {
        title: 'Atenção',
        text: `Deseja excluir o arquivo "${value.cName}" ?`,
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não'
      }

      messenger.show(options).then((result) => {
        if (result.value) {
          this.importerService.deleteFile(value.gdIdEvent).then((res) => {
            if ((res.status === 200) || (res.status === 204)) {
              messenger.info({position: 'center', title: 'Arquivo excluído.'})
              self.getFiles()
            } else {
              const message = res.data.message || res.data || `Erro ao obter os arquivos`;
              messenger.error({ position: 'center', title: message })
            }
          }, (error) => {
            const message = res.data.message || res.data || `Erro ao obter os arquivos`;
            console.error(message)
            messenger.error({ position: 'center', title: message })
          })
        }
        self.busy = false
      })
    },
    showPageConfigTable (value) {
      this.$router.push({name: 'config-table', query: { file: value.gdIdEvent }, params: {fileItem: value}})
      this.$emit('modalClose', true)
    },
    formatClass(value){
      let resp = value
      resp =  resp.replace('.csv', '');
      resp = resp.replace('.xls', '');

      return resp
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    formatHora (date) {
      return moment(date).format('LTS')
    }
  },
  created () {
    this.listenSocketQueues()
    this.getConfig()
    this.getFiles()
  },
  computed: {

  },
  mounted () {

  },
  watch: {
    currentPage(n, o) {
      this.getFiles()
    }
  }
}
</script>

<style src="@/vendor/styles/pages/file-manager.scss" lang="scss"></style>
<style src="@/vendor/libs/vue-dropzone/vue-dropzone.scss" lang="scss"></style>
<style src="@/vendor/libs/spinkit/spinkit.scss" lang="scss"></style>
<style>
  @import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/bootstrap.css";
  @import "../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/bootstrap.css";
  /*@import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/fabric.css";*/

  .e-tool-name {
    font-style: normal;
    font-size: 18px;
    font-weight: bold;
    cursor: default;
    padding-left: 5px;
    font-variant: small-caps;
  }
  .e-close-icon::before {
    content: '\e7e9';
    color: #e60000;
    font-size: x-large;

  }

  .control-wrapper {
    margin: 0 auto;
    width: 250px;
  }

  .AccordionColor {
    background: #eeeeee; /* Old browsers */
    background: -moz-linear-gradient(top, #eeeeee 0%, #cccccc 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, #eeeeee 0%, #cccccc 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, #eeeeee 0%, #cccccc 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#eeeeee', endColorstr='#cccccc', GradientType=0); /* IE6-9 */
    color: black;
    border: none !important;
    border-color: transparent !important;
  }

  .AccordionColor a:hover {
    color: white;
  }

  .AccordionColor a:active {
    color: white;
  }

  .AccordionColor a:visited {
    color: white;
  }
</style>
